/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_EventsInputs */

const en_header_events = /** @type {(inputs: Header_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Header_EventsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_events = /** @type {((inputs?: Header_EventsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_EventsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_events(inputs)
});